import React from 'react';
import { LinkButton } from '@ab-inbev-maz/compass';
import { BannerInfo } from '../components/BannerInfo';

import image_combos from '../assets/images/image_combos.jpg';
import image_reglas from '../assets/images/image_reglas.jpg';
import image_templates from '../assets/images/image_template.jpg';
import image_skus from '../assets/images/image_sku.jpg';
import image_manualidades from '../assets/images/image_manuals.png';
import image_config from '../assets/images/image_config.png';
import image_legals from '../assets/images/image_legals.png';

const emptyIconStyle = {
  '--button-empty-icon-width': '0'
};

const DashboardPage: React.FC = () => {

  const cards = [
    { id: 'templates', 
      title: 'Creación de Templates', 
      description: 'Diseña y guarda estructuras reutilizables para combos y banners, optimizando tiempos y estilo gráfico.', 
      icon: image_templates, 
      button: 'Crea tu template', 
      url: '/templates' },
    { id: 'combos', 
      title: 'Imagenes Creadas', 
      description: 'Revisa los combos de productos para promociones en BEES que se han generado.', 
      icon: image_combos, 
      button: 'Revisa tus combos', 
      url: '/combos/table' },
    { id: 'banners', 
      title: 'Creación de reglas', 
      description: 'Define y establece las reglas necesarias para la creación de tus combos.', 
      icon: image_reglas, 
      button: 'Crea tus reglas', 
      url: '/rules' },
    { id: 'skus', 
      title: 'Listado de SKU´s', 
      description: 'Consulta SKUs actualizados con datos clave para armar combos, banners y campañas fácilmente.', 
      icon: image_skus, 
      button: 'Accede a la librería', 
      url: '/skus/table' },
    { id: 'manualidades', 
      title: 'Manualidades', 
      description: 'Crea manualidades para tus combos y banners, optimizando tiempos y estilo gráfico.', 
      icon: image_manualidades, 
      button: 'Crea tu manualidad', 
      url: '/manualidades' },
    // { id: 'legals', 
    //   title: 'Legales', 
    //   description: 'Crea legales para tus combos y banners, optimizando tiempos y manteniendo coherencia gráfica.', 
    //   icon: image_legals,
    //   button: 'Crea tu legal', 
    //   url: '/legals/table' },
    // { id: 'general_config',
    //   title: 'Configuraciones generales',
    //   description: 'Consulta taxonomías para organizar y clasificar contenidos con facilidad.',
    //   icon: image_config,
    //   button: 'Configuración',
    //   url: '/settings' },
  ];

  return (
    <>
      <BannerInfo />
      <div className="p-8">            

        <div className="mb-8 grid gap-4 max-w-7xl mx-auto grid-cols-[repeat(auto-fill,minmax(230px,1fr))] justify-items-center">

          {
            cards.map((card) => (
              <div
                key={card.id}
                className="bg-white rounded-lg shadow-[0px_4px_16px_rgba(32,32,32,0.16)] w-full mb-8 flex flex-col  min-h-64 max-w-80 overflow-hidden"
              >
                  <div className="flex flex-col gap-spacing-xs items-start justify-start self-stretch flex-1 relative">
                    <div className="aspect-[3/2] flex flex-row gap-y-2 items-center justify-between flex-wrap content-center self-stretch shrink-0 relative">
                      <img
                        className="w-full h-full object-cover"
                        src={card.icon}
                      />
                    </div>
                    <div className="p-4 flex flex-col gap-spacing-s items-start justify-between self-stretch flex-1 relative mt-2">
                      <div className="flex flex-col gap-0 items-start justify-start self-stretch shrink-0 relative">
                        <div className="text-left text-2xl font-bold text-gray-800 mb-2">
                          {card.title}
                        </div>
                      </div>
                      <div className="text-left overflow-hidden text-gray-600 text-sm mb-2">
                        {card.description}
                      </div>  
                      <LinkButton 
                        className='w-full flex items-center justify-between mt-4' 
                        style={emptyIconStyle}
                        rightIcon='arrow/arrow-right' 
                        label={card.button} 
                        variant='primary' 
                        to={card.url}/>
                    </div>
                  </div>
                </div>
            ))
          }
        </div>

      </div>
    </>
  );
};

export default DashboardPage;
